import { Grid } from '@mui/material';
import Img from 'next/image';
import Title from './Title';
import Optional from '../../../Optional';
import { SectionTitleType } from '../../../../utils/mappers/sectionTitleMapper';

type Props = {
  data: SectionTitleType;
  isMobile: boolean;
};

const SectionTitle = ({ data, isMobile }: Props) => {
  const image = data.image;
  const hasImage = !!image?.url;
  const height = isMobile ? 60 : 120;
  const ar = image?.meta?.aspectRatio || 1;
  const imageWidth = ar * height;
  return (
    <Grid container spacing={2}>
      <Optional condition={hasImage}>
        <Grid size={{ xs: 12, md: 3 }}>
          <Img
            src={image?.url || ''}
            alt={image?.altText || ''}
            width={imageWidth}
            height={height}
          />
        </Grid>
      </Optional>
      <Grid
        size={{ xs: 12, md: hasImage ? 9 : 12 }}
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Title data={data} isMobile={isMobile} />
      </Grid>
    </Grid>
  );
};

export default SectionTitle;
